import { BaseComponent } from "../../BaseComponent";
import { DocumentBox } from "./DocumentBox/DocumentBox";
import {
    AddDocumentComponent,
    AddDocumentFieldClass,
    FieldType,
    IAddDocumentField
} from "./AddDocument/AddDocumentComponent";
import * as React from "react";
import { DropEvent } from "react-dropzone";
import { BottoneAPI } from "../../BottoneAPI";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { CDocumentExtended } from "../../../Dati";
import { CDocument } from "../../../Dati";

interface IDocumentComponentState {
    IsBoxComponent: boolean;
    InputFile: File | null;
    AdditionalData: CDocumentExtended | null;
    IsUpdate: boolean;
}

interface IDocumentComponentProps {
    OnErroreBottoneAPI: (sender: BottoneAPI) => void;
    OnSubmitSave: (InputFile?: File, AdditionalData?: CDocument) => void;
    OnFileSaved: (dati: Dati.CRisAPI) => void;
    GetDocumentsList: () => void;
    SaveURL: string;
    OnRemove: (file: CDocumentExtended) => void;
    Label: string;
    Files: Glob.DatiJSON;
    SpecialInformationEnabled?: boolean;
    DeleteEnabled?: boolean;
    AddEnabled?: boolean;
}

const allFields: IAddDocumentField[] = [
    {
        KeyName: "ID_Document",
        Label: "Document Id",
        Placeholder: "Document Id",
        Readonly: true,
        Icon: "",
        Type: FieldType.LEFT
    },
    {
        KeyName: "OriginalFileName",
        Label: "Original file name",
        Placeholder: "OriginalFileName",
        Readonly: true,
        Icon: "",
        Type: FieldType.LEFT
    },
    {
        KeyName: "DownloadFileName",
        Label: "Download filename",
        Placeholder: "DownloadFileName",
        Readonly: false,
        Icon: "",
        Type: FieldType.LEFT
    },
    {
        KeyName: "SHA256",
        Label: "SHA256",
        Placeholder: "SHA256",
        Readonly: true,
        Icon: "",
        Type: FieldType.CENTER
    },
    { KeyName: "MIME", Label: "MIME", Placeholder: "MIME", Readonly: true, Icon: "", Type: FieldType.CENTER },
    {
        KeyName: "Description",
        Label: "Description",
        Placeholder: "Description",
        Readonly: false,
        Icon: "",
        Type: FieldType.CENTER
    },
    {
        KeyName: "Version",
        Label: "Version",
        Placeholder: "Version",
        Readonly: true,
        Icon: "",
        Type: FieldType.SIBLING
    },
    {
        KeyName: "Type",
        Label: "Type",
        Placeholder: "Type",
        Readonly: true,
        Icon: "Yes",
        Type: FieldType.SIBLING
    }
];

export class DocumentComponent extends BaseComponent<IDocumentComponentProps, IDocumentComponentState> {
    constructor(props: any) {
        super(props);
        this.state = { IsBoxComponent: true, InputFile: null, AdditionalData: null, IsUpdate: false };
        this.ChangeComponent = this.ChangeComponent.bind(this);
        this.OnDrop = this.OnDrop.bind(this);
        this.OnSelect = this.OnSelect.bind(this);
        this.OnSubmitSave = this.OnSubmitSave.bind(this);
        this.OnDownloadFile = this.OnDownloadFile.bind(this);
    }

    ChangeComponent() {
        this.setState({ IsBoxComponent: !this.state.IsBoxComponent });
    }

    GetFields(): IAddDocumentField[] {
        return allFields.map(field => new AddDocumentFieldClass(field));
    }

    private OnDrop(acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) {
        const Data = acceptedFiles.length ? acceptedFiles[0] : null;
        this.setState({ InputFile: Data });
    }

    private OnSelect(acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) {
        if (!event || event.type === "change") {
            this.setState({ InputFile: acceptedFiles[0] });
        }
    }

    private OnSubmitSave(InputFile?: File, AdditionalData?: CDocument) {
        const File = InputFile ? InputFile : this.state.InputFile;
        return this.props.OnSubmitSave(File as File, AdditionalData);
    }

    private OnFileSaved(data: any) {
        this.setState({ InputFile: null })
        this.props.OnFileSaved(data);
    }

    private OnDownloadFile(document: Dati.CDocumentExtended) {
        this.setState({ AdditionalData: document, IsUpdate: true });
        this.ChangeComponent();
    }

    render() {
        const fields: IAddDocumentField[] = this.GetFields();

        return this.state.IsBoxComponent ?
            <DocumentBox OnComponentChange={this.ChangeComponent} OnDrop={this.OnDrop} Files={this.props.Files}
                InputFile={this.state.InputFile as File} SaveURL={this.props.SaveURL}
                AcceptedFiles={".pdf, .doc, .docx, .jpg, .png"}
                Label={this.props.Label} OnFileSaved={(data) => this.OnFileSaved(data)}
                OnRemove={this.props.OnRemove} AddEnabled={this.props.AddEnabled} OnDownloadFile={this.OnDownloadFile}
                OnErroreBottoneAPI={this.props.OnErroreBottoneAPI} OnSubmitSave={this.OnSubmitSave} />
            :
            <AddDocumentComponent OnComponentChange={() => {
                this.ChangeComponent();
                this.setState({ IsUpdate: false, AdditionalData: null })
            }}
                OnSelect={this.OnSelect} Fields={fields}
                OnFileSaved={(data) => this.OnFileSaved(data)} AcceptedFiles={".pdf, .doc, .docx, .jpg, .png"}
                InputFile={this.state.InputFile as File} AdditionalData={this.state.AdditionalData}
                SaveURL={this.state.IsUpdate ? "/api/Document" : this.props.SaveURL}
                OnErroreBottoneAPI={this.props.OnErroreBottoneAPI}
                OnSubmitSave={this.OnSubmitSave}
                SpecialInformationEnabled={this.props.SpecialInformationEnabled}
                AddEnabled={this.props.AddEnabled}
            />;
    }
}



// WEBPACK FOOTER //
// ./src/components/custom/Document/DocumentComponent.tsx